import Typography from '@material-ui/core/Typography';
import styled from 'styled-components';

export const Container = styled.div`
    text-align: center;
    margin: 16px;
`;

export const StyledTypography = styled(Typography)`
    margin-top: 8px !important;
`;
